export const CHAT_LIST_FEATURE_KEY = 'chat-list';
